<template>
  <div class="alert alert-warning" role="alert">
    Izpolnite obvezne podatke<template v-if="missing?.length"
      >: <strong>{{ missing.join(", ") }}</strong></template
    >!
    <div class="small mt-1" v-if="$slots.default">
      <slot />
    </div>
  </div>
</template>

<script setup>
defineOptions({ name: "RequiredWarning" })

defineProps({
  // labels of the missing fields
  missing: { type: Array, default: () => [] },
})
</script>
